import { render, staticRenderFns } from "./UpsertProviderModal.vue?vue&type=template&id=797a7fdf&"
import script from "./UpsertProviderModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertProviderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports